export default __webpack_public_path__ + "634b7c6d113101bd0b7923e7e3780915.png";